// This file maps state to stores, and also exposes a fetchData function to
// fetch all the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';
import BotStore from '@src/store';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [CommonStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  const metatags = CommonStore.getMetaTags();
  return {
    domain: metatags.domain,
    story: metatags.story,
    subStory: metatags.subStory,
    nodeContextMenuEnabled: BotStore.getEnableNodeContextMenuFlag(),
  };
}

/**
 * These functions are exported from here rather than being imported directly
 * into the containers to keep a proper separation and maintain the ability
 * to refactor easily later if needed. All the functions are then available as
 * maps.*
 */
export { createNode } from '@src/actions/SubstoryActions';
export {
  closeComponentModal,
  updateComponentModal,
  createAlert,
  getSubstoryGraph,
} from '@src/actions/BotActions';
export { updateGraph } from 'actions/ApiAction';
